import { Control, useWatch } from 'react-hook-form';

import type { TemplateFormSchema } from '../validations/edit-template.validation';

import { hasFile } from '../utils/has-file.util';

type BaseParams = {
  control: Control<TemplateFormSchema>;
  currentStep: number;
  isValid: boolean;
};

type CreateParams = { mode: 'create' } & BaseParams;

type EditParams = {
  isDirty: boolean;
  mode: 'edit';
  templateFileLink: string;
} & BaseParams;

export type StepThreeSubmitStateParams = CreateParams | EditParams;

export const useStepThreeSubmitState = (
  params: StepThreeSubmitStateParams,
): { isNextOrSubmitDisabled: boolean } => {
  const { control, currentStep, isValid } = params;
  const isEditMode = params.mode === 'edit';

  const file = useWatch({ control, name: 'stepThree.file' });
  const fileParsed = useWatch({ control, name: 'stepThree.fileParsed' });
  const mergeFieldIssues =
    useWatch({ control, name: 'stepThree.mergeFieldIssues', defaultValue: [] }) ?? [];

  const hasFileValue = hasFile(file) || isEditMode;
  const step3Blocked = currentStep === 3 && (!hasFileValue || fileParsed === false);

  const noChangesInEditMode = isEditMode && currentStep === 3 && params.isDirty === false;

  const mergeFieldErrorsBlockProgress = mergeFieldIssues.length > 0 && currentStep >= 3;

  const isNextOrSubmitDisabled =
    step3Blocked || !isValid || noChangesInEditMode || mergeFieldErrorsBlockProgress;

  return { isNextOrSubmitDisabled };
};
